import { useInView, motion } from "framer-motion";
import { useEffect, useRef, useState } from "react";

const Policy = ({ref}) => {
    const isInView = useInView(ref, { once: true, margin: "-100px" });
    const [isMobile, setMobile] = useState(false);

    useEffect(() => {
        const handleResize = () => setMobile(window.innerWidth <= 768);
        window.addEventListener('resize', handleResize);
        handleResize();
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    return (
        <motion.div
            ref={ref}
            initial={{ opacity: 0, y: 30 }}
            animate={isInView ? { opacity: 1, y: 0 } : {}}
            transition={{ duration: 0.8 }}
            style={{
                padding: isMobile ? "4rem 1.5rem" : "6rem 10%",
                backgroundColor: "#fff", // Aradaki beyaz yer
                display: "flex",
                flexDirection: "column",
                alignItems: "center"
            }}
        >
            <div style={{
                width: "100%",
                maxWidth: "1100px",
                padding: isMobile ? "2rem" : "4rem",
                borderRadius: "20px",
                background: "#fdfdfd",
                border: "1px solid #eee",
                boxShadow: "0 10px 40px rgba(0,0,0,0.03)",
                position: "relative",
                overflow: "hidden"
            }}>
                {/* Sol üst köşeye kurumsal bir dokunuş */}
                <div style={{
                    position: "absolute",
                    top: 0,
                    left: 0,
                    width: "6px",
                    height: "100%",
                    backgroundColor: "#1a7373"
                }} />

                <h2 style={{
                    fontSize: isMobile ? "1.8rem" : "2.5rem",
                    fontWeight: "800",
                    color: "#333",
                    marginBottom: "2rem",
                    textAlign: "left"
                }}>
                    Politikamız
                </h2>

                <p style={{
                    fontSize: isMobile ? "1rem" : "1.15rem",
                    lineHeight: "1.9",
                    color: "#555",
                    textAlign: "justify",
                    fontWeight: "300"
                }}>
                    Güçlükaya İnşaat San. ve Tic. Ltd. Şti. olarak politikamız; faaliyet gösterdiğimiz 
                    inşaat sektöründe yasal şartlar, mevzuatlar ve teknik şartnamelere tam uyum sağlamaktır. 
                    İş hacmini sürekli geliştirerek ülke ekonomisine katkıda bulunmak, inşaat sektöründeki 
                    teknolojik gelişmeleri yakından takip ederek projelerimizde uygulamak temel önceliğimizdir. 
                    İş sağlığı ve güvenliği çerçevesinde; iş kazalarını ve meslek hastalıklarını önlemek adına 
                    gerekli tüm tedbirleri almak, çevreyi korumak ve işçi sağlığını her zaman en ön planda 
                    tutmak vazgeçilmez ilkemizdir. Kalite yönetim sistemimizi sürekli iyileştirerek, 
                    müşteri memnuniyetini en üst düzeyde tutmayı ve verdiğimiz tüm taahhütleri zamanında, 
                    eksiksiz ve en yüksek kalite standartlarında yerine getirmeyi taahhüt ederiz.
                </p>
            </div>
        </motion.div>
    );
};

export default Policy;